var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"font-weight-regular text-caption",class:_vm.currentStatus.color,staticStyle:{"padding":"1px 4px","border-radius":"4px"}},[_vm._v(_vm._s(_vm.currentStatus.name))])
}
var staticRenderFns = []

export { render, staticRenderFns }